import { CountryCodes } from '@/generated/graphql';

export const URL_PARAM_REGEX_WHITE_LIST = {
  elmo: /^elmo_feature_/,
  featureFlag: /^xo__/,
} as const;

export const validOneTouchCountries = [
  CountryCodes.Us,
  CountryCodes.Ca,
  CountryCodes.Au,
];
